<template>
    <div class="row data-row">
        <div class="data-back">
            <div class="col-md-4" v-for="link of links" :key="link.id">
                <a class="mid-links" href="/flavors">
                    <p>
                        <img src="../assets/img/full-brigadeiro.svg" class="img-responsive middle-images" />
                    </p>
                    <h2 class="middle-heading text-center">Flavors</h2>
                    <p class="text-center">
                        <img src="../assets/img/lace-accent.svg" class="lace-image" />
                    </p>
                </a>

            </div>
                <div class="col-md-4" v-for="link of links" :key="link.id">
                <a class="mid-links" href="/content/packages">
                    <p>
                        <img src="../assets/img/gift-box.svg" class="img-responsive middle-images" />
                    </p>
                    <h2 class="middle-heading text-center">Packages</h2>
                    <p class="text-center">
                        <img src="../assets/img/lace-accent.svg" class="lace-image" />
                    </p>
                </a>

            </div>
             <div class="col-md-4" v-for="link of links" :key="link.id">
                <a class="mid-links" href="/content/events">
                    <p>
                        <img src="../assets/img/events.svg" class="img-responsive middle-images" />
                    </p>
                    <h2 class="middle-heading text-center">Events</h2>
                    <p class="text-center">
                        <img src="../assets/img/lace-accent.svg" class="lace-image" />
                    </p>
                </a>

            </div>
       </div>
    </div>
</template>
<script>
export default {
    name: 'Mainlinks',
    props: ['links']
}
</script>
<style lang="scss">
.lace-image {
    height: 20px;
    position: relative;
    top: -5px;
}
.data-row {
    background-color: #FFa9a9;
    background: url('../assets/img/paris-back.svg') no-repeat fixed right #fabcbc;
    background-size: cover;
    margin-left: 0;
    margin-right: 0;
    margin-top: -100px;
}
.data-back {
    background-color: rgba(255,166,166,0.6);
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .mid-links {
    
    &:hover {
        background-color: #FFa9a9;
        text-decoration: none;
        .middle-heading {
            color:#b76565;
        }
       
    }
    text-decoration: none;
    display: block;
    padding-bottom: 125px;
    padding-top: 125px;
    p {
        padding: 0;
    }
}
}
.middle-images {
    height: 100px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    border: 0px solid #ffedd6;
}

.middle-heading {
    font-family: "lust-script",sans-serif;
    font-size: 30pt;
    color: #300B02;
}


</style>